import BaseModal from 'src/components/primitives/BaseModal/BaseModal';
import Button from 'src/components/primitives/Button/Button';
import WarningFilled from 'src/components/Icons/WarningFilled';

interface DeleteAlertModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

export default function DeleteAlertModal({
	open,
	onClose,
	onConfirm,
}: DeleteAlertModalProps) {
	if (!open) return null;

	return (
		<BaseModal.Container onClose={onClose} className="w-[368px]">
			<div className="flex flex-col items-center gap-lg bg-container-bg pt-lg">
				<WarningFilled size={64} />
				<div className="flex flex-col items-center gap-lg p-lg text-center">
					<h5 className="typo-t2 text-text-default">Delete Alert</h5>
					<p className="typo-b3 text-text-default">
						Are you sure you want to delete this alert?
					</p>
				</div>
			</div>
			<BaseModal.Footer className="gap-md">
				<Button
					size="lg"
					variant="secondary"
					className="flex-1"
					onClick={onClose}
				>
					Cancel
				</Button>
				<Button
					size="lg"
					variant="primary"
					className="flex-1"
					onClick={onConfirm}
				>
					Delete
				</Button>
			</BaseModal.Footer>
		</BaseModal.Container>
	);
}
